import React from 'react';
import { Box } from '@applyboard/ui-components';
import { BookOutlineIcon, BuildingOutlineIcon, BarGraphFillIcon } from '@applyboard/ui-icons';
import { displayDesktopOnly } from "../../consts";
import { TitleIconContent, TitleIconContainer } from "./styles";
function TitleIcon(Icon) {
  // eslint-disable-next-line react/display-name
  return function () {
    return /*#__PURE__*/React.createElement(Box, {
      display: displayDesktopOnly
    }, /*#__PURE__*/React.createElement(TitleIconContainer, null, /*#__PURE__*/React.createElement(TitleIconContent, null, /*#__PURE__*/React.createElement(Icon, {
      color: "primary.dark"
    }))));
  };
}
export var TitleIcons = {
  SimilarPrograms: /*#__PURE__*/React.memo(TitleIcon(BookOutlineIcon)),
  ProgramSummary: /*#__PURE__*/React.memo(TitleIcon(BuildingOutlineIcon)),
  AdmissionRequirements: /*#__PURE__*/React.memo(TitleIcon(BarGraphFillIcon))
};